import { render } from "./TextNumBlock.vue?vue&type=template&id=c8df9f78&scoped=true"
import script from "./TextNumBlock.vue?vue&type=script&lang=js"
export * from "./TextNumBlock.vue?vue&type=script&lang=js"

import "./TextNumBlock.vue?vue&type=style&index=0&id=c8df9f78&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8df9f78"]])

export default __exports__